import { NotificationService } from 'app/core/services/notification.service';
import { HttpParams } from '@angular/common/http';
import { Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { catchError, tap, map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { HttpClient,  HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { BaseService } from './base-service';
import { ResponsePageable } from './responsePageable';
import * as FileSaver from 'file-saver';
export abstract class BaseReportService<T> extends BaseService {

    extraQueryCondition: any;
    extraSearchFields: any ;

    constructor(injector: Injector) {
        super(injector); 
        //this.notificationService = this.injector.get(NotificationService); 
    }

    
    abstract buildSentence(entity?: T, event?: LazyLoadEvent): HttpParams;
    protected addLogicToSearch(value: T) {};
    protected addLogicToGetOne(value: T) {};

    search(entity?: T, event?: LazyLoadEvent, extraQueryCondition?: string): Observable<ResponsePageable<T>> {
 
        let url= "${environment.apiUrl}:8083/personalModule/api/absenceLeave/";
        
        this.spinnerService.showAll();
        return this.httpClient.get<ResponsePageable<T>>(url, { params: this.buildSentence(entity, event) })
            .pipe(
                tap(response => {
                    if (response.numberOfElements > 0) {
                        response.content.forEach((value) => {
                            // debugger;
                            this.addLogicToSearch(value);
                            this.convertToDate(value);
                        })
                    } 
                    this.spinnerService.hideAll();
                    return response;
                })
            );
    }



    getOneById(id: string | number): Observable<T> {
        // debugger;
        const url = this.rutaServidor + this.uri + id;
        this.spinnerService.showAll();
        return this.httpClient.get<T>(url)
            .pipe(
                tap((response: ResponsePageable<T>) => {
                    
                    if (response.numberOfElements > 0) {
                        this.convertToDate(response.content[0]);
                    }
                    this.spinnerService.hideAll();
                }),
                map((response: ResponsePageable<T>) => response.content[0])
            );
    }

    getOneByCode(code: string | number): Observable<T> {
        // debugger;
        const url = this.rutaServidor + this.uri + 'code/' + code;
        this.spinnerService.showAll();
        return this.httpClient.get<T>(url)
            .pipe(
                tap((response: ResponsePageable<T>) => {
                    
                    if (response.numberOfElements > 0) {
                        this.convertToDate(response.content[0]);
                    }
                    this.spinnerService.hideAll();
                }),
                map((response: ResponsePageable<T>) => response.content[0])
            );
    }


    searchTest(entity?: T, event?: LazyLoadEvent, extraQueryCondition?: string): Observable<ResponsePageable<T>> {
       // debugger;
         const url = this.rutaServidor + this.uri;  
        this.spinnerService.showAll();
        return this.httpClient.get<ResponsePageable<T>>(url, { params: this.buildSentence(entity, event) })
            .pipe(
                tap(response => {
                    debugger;
                    if (response.numberOfElements > 0) {
                        response.content.forEach((value) => {
                            // debugger;
                            this.addLogicToSearch(value);
                            this.convertToDate(value);
                        })
                    } 
                    this.spinnerService.hideAll();
                    return response;
                })
            );
    }

    /*********************/
    /* Metodos Download  */
    /*********************/ 
    
 
    downloadExcel(url:string ,object: any , nameFile : string): Observable<Blob> {
        let ruta = this.rutaServidor + this.uri   +  url;
        //console.log("ruta : "  + ruta);
         this.spinnerService.showAll(); 
        return this.httpClient.post(ruta, object, {responseType: 'blob' })
            .pipe( 
                map(res =>  {   
                    this.spinnerService.hideAll();
                    let bean = new Blob([res],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                    FileSaver.saveAs(bean, nameFile);
                    return bean;
                }),
                catchError((err, caught) => { 
                    //console.log("catchError : "  + catchError);
                    this.spinnerService.hideAll(); 
                    this.notificationService.serverErrorMessage(err.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
                    return new Observable<Blob>();
                }) 
                 
            ); 
 
    }
 
    downloadPDF(url:string ,object: any , nameFile : string): Observable<Blob> {
        let ruta = this.rutaServidor + this.uri   +  url; 
        this.spinnerService.showAll();
        return this.httpClient.post(ruta, object, {responseType: 'blob' })
            .pipe( 
                map(res =>  { 
                    this.spinnerService.hideAll();
                    let bean = new Blob([res],{ type: 'application/zip'});
                    FileSaver.saveAs(bean, nameFile);
                    return bean;
                 }   ),
                catchError((err) => { 
                    //console.log("catchError : "  + catchError);
                   this.spinnerService.hideAll();
                   this.notificationService.serverErrorMessage(err.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
                   return new Observable<Blob>();
                })
                 
                ) ;
 
    }

     



    /**
    downloadPDF(url:string): Observable<Blob> {
        let ruta = this.rutaServidor + this.uri + url;
        debugger;
        return this.httpClient.get(ruta, {responseType: 'blob'})
            .pipe(
                map(res =>  {
                    debugger;
                    let bean = new Blob([res],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                    return bean;
                }),
                catchError((err, caught) => {
                    debugger;
                    //this.handleError(err);
                    return new Observable<Blob>();
                })
            );

    }
 */
}



// WEBPACK FOOTER //
// ./src/app/shared/_utils/services/base-report-service.ts